import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { getUserData } from "../../../utils/localStorage";
import { storeCustomerGetInfo } from "../../../services/CustomerInfo/CustomerInfo";
import { getCustomerSingleB2BOrderInfo } from "../../../services/OrdersAPI/Orders";
import { getStoreDefaultPrice } from "../../../services/StoreDefaultPrice/getStoreDefaultPrice";
import SuccessModal from "../../SuccessModal";
import AdminMenu from "../../AdminMenu";
import { getBrandStoreById } from "../../../services/StoreUsers/PostStoreUsers";
import B2BOrderInfoCard from "./B2BOrderInfoCard";
import B2BGarmentInfoCard from "./B2BGarmentInfoCard";
import B2BOrderCancelModal from "./B2BOrderCancelModal";
import B2BOrderInfoEdit from "./B2BOrderInfoEdit";

const { innerWidth: width, innerHeight: height } = window;

const CardDataOnDoneOrder = [
    {
        id: 3,
        name: "Cancel Order",
        fillColor: "#FFEEEE",
        borderColor: "#FF6767",
        img: "Laundy_App_Icons_Gifs/Other_Icons/Cancel_Order.png",
    },
];


const CardDataAfterCancelOrder = [
    {
        id: 1,
        name: "Canceled Order",
        // fillColor: '#E7F4FF', // You can set the desired colors
        borderColor: "red", // You can set the desired colors
        img: "Laundy_App_Icons_Gifs/Customer_Info_GIFs/Cancel_Order.gif", // Provide the correct image path
    },
];

const B2BAdminOrdersGarmentInfo = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const { storeIdValue, bookingOrderId, storeCustomerId, navigateThrough } = location.state || {}; // Fallback to prevent undefined errors

    let storeId = storeIdValue;

    const {
        brandProfileData,
        userProfileData,
        userProfileRole,
        garmentCategoryServiceIconsResData,
    } = getUserData();

    const [storeData, setStoreData] = useState({})

    const userRole = userProfileRole;

    let brandId = brandProfileData.id;
    const storeUserId = userProfileData.id;
    const processTime = storeData.processTime;
    const storeGstNumber = storeData.gstNo;
    const enabledChargeDiscountByService =
        storeData.enabledChargeDiscountByService;
    let enabledCreatePaymentLink = storeData.enabledCreatePaymentLink;
    let offerPriceEnabled = storeData.offerPriceEnabled;
    const garmentMaxProcessCount = brandProfileData.garmentMaxProcessCount;

    const offerDiscountByStore = storeData.offerDiscountByStore;
    const offerDiscountByRider = storeData.offerDiscountByRider;

    const [processOrderActive, setProcessOrderActive] = useState(null);
    const [modalVisible, setModalVisible] = useState(false);
    const [cancelOrderModal, setCancelOrderModal] = useState(false);
    const [modalText, setModalText] = useState("");
    const [modalStatusText, setModalStatusText] = useState("");
    const [customerOrdersData, setCustomerOrdersData] = useState({});
    const [storeCustomerData, setStoreCustomerData] = useState({});
    const [orderInfoEditVisible, setOrderInfoEditVisible] = useState(false);
    const [storeDefaultPrice, setStoreDefaultPrice] = useState([]);
    
    const [visible, setVisible] = useState(false);
    const handleBackButton = () => {
        if (navigateThrough === 'GoBack') {
            navigate(-1)
        } else {
            navigate('/');
        }
    };

    const fetchStoreUser = () => {
        getBrandStoreById(storeId)
            .then((response) => {
                if (!response.data.error) {
                    const Res = response.data;
                    setStoreData(Res);
                }
            })
            .catch((err) => {
                console.error("Error:", err);
            });
    };

    const fetchStoreCustomerGetInfo = () => {
        storeCustomerGetInfo(storeCustomerId, storeId)
            .then((response) => {
                if (!response.data.error) {
                    const Res = response.data;
                    setStoreCustomerData(Res);
                }
            })
            .catch((err) => {
                console.error("storeCustomerGetInfo Error:", err);
            });
    };

    const fetchCustomerSingleOrder = () => {
        // getCustomerSingleOrder(storeCustomerId, storeId, bookingOrderId)
        getCustomerSingleB2BOrderInfo(storeCustomerId, storeId, bookingOrderId)
            .then((response) => {
                if (!response.data.error) {
                    const Res = response.data;
                    setCustomerOrdersData(Res);
                }
            })
            .catch((err) => {
                console.error("getCustomerSingleOrder Error:", err);
            });

    };

    const fetchDefaultPrice = () => {
        getStoreDefaultPrice(storeId)
            .then((response) => {
                if (!response.data.error) {
                    const Res = response.data;
                    setStoreDefaultPrice(Res);
                }
            })
            .catch((err) => {
                console.error("Error:", err);
            });
    };


    const [collectPaymentResponse, setCollectPaymentResponse] = useState(null);

    const receiveResponse = ({ message, status, modalFun }) => {
        setModalStatusText(status ? "success" : "failed");
        setModalText(message);
        setCollectPaymentResponse(modalFun);
        fetchCustomerSingleOrder();
        // setCollectPaymentModalVisible(modalFun);
    };

    useEffect(() => {
        if (collectPaymentResponse === false) {
            setModalVisible(true);
            setCollectPaymentResponse(null);
        }
    }, [collectPaymentResponse]);

    useEffect(() => {
        fetchStoreUser();
        fetchCustomerSingleOrder();
        fetchStoreCustomerGetInfo();
        fetchDefaultPrice();
    }, []);

    const CustomerInformation = {
        firstName: storeCustomerData?.brandCustomer?.firstName
            ? storeCustomerData?.brandCustomer?.firstName
            : "",
        lastName: storeCustomerData?.brandCustomer?.lastName
            ? storeCustomerData?.brandCustomer?.lastName
            : "",
        mobile: storeCustomerData?.brandCustomer?.mobile
            ? storeCustomerData?.brandCustomer?.mobile
            : "N/A",
    };

    

    const orderItemData = customerOrdersData?.orderItem;

    const receiveDataFromCancelModal = ({ dataRes }) => {
        // setSchedularDate(newSchedular);
        if (dataRes) fetchCustomerSingleOrder();
    };

    const onSelectCategoryOnDoneOrder = (item) => {
        
        if (item.id === 3) {
            setCancelOrderModal(true);
        } else {
            navigate("/");
        }
    };



    const receiveDataFromGarmentInfoCard = ({ info }) => {
        if (info) {
            fetchCustomerSingleOrder();
            fetchStoreCustomerGetInfo();
            fetchDefaultPrice();
        }
    };

    const renderCardOnDoneOrder = () => {
        return CardDataOnDoneOrder?.map((item, index) => {
            return (
                <div
                    className="cursor-pointer"
                    onClick={() => {
                        {
                             onSelectCategoryOnDoneOrder(item);
                        }
                    }}
                >
                    <div className="flex justify-content-center align-items-center">
                        <div
                            className="flex justify-content-center align-items-center border-1"
                            style={{
                                height: height < 600 ? 51 : 61,
                                width: height < 600 ? 51 : 61,
                                backgroundColor: item.fillColor,
                                borderRadius: 50,
                                borderColor: item.borderColor,
                            }}
                        >
                             
                                <img
                                    src={item.img}
                                    style={{
                                        width: height < 600 ? 25 : 30,
                                        height: height < 600 ? 25 : 30,
                                        alignSelf: "center",
                                    }}
                                />
                        </div>
                    </div>

                    <div className="py-2">
                        <p
                            className="text-xl font-normal capitalize"
                            style={
                                index === 0 && processOrderActive === item.id
                                    ? { color: "#008EFF" }
                                    : { color: "#75879B" }
                            }
                        >
                            {item.name}
                        </p>
                    </div>
                </div>
            );
        });
    };



    const renderCardAfterCancelOrder = () => {
        return CardDataAfterCancelOrder?.map((item, index) => (
            <div>
                <div className="flex justify-content-center align-items-center">
                    <div
                        className="flex justify-content-center align-items-center border-1"
                        style={{
                            height: height < 600 ? 51 : 61,
                            width: height < 600 ? 51 : 61,
                            backgroundColor: item.fillColor,
                            borderRadius: 50,
                            borderColor: item.borderColor,
                        }}
                    >
                        <img
                            src={item.img}
                            style={{
                                width: height < 600 ? 25 : 30,
                                height: height < 600 ? 25 : 30,
                                alignSelf: "center",
                            }}
                        />
                    </div>
                </div>

                <div className="py-2">
                    <p
                        className="text-xl font-normal capitalize"
                        style={
                            index === 0 && processOrderActive === item.id
                                ? { color: "#008EFF" }
                                : { color: "#75879B" }
                        }
                    >
                        {item.name}
                    </p>
                </div>
            </div>
        ));
    };


    return (
        <div className="flex-1">
            <div
                className="h-3rem surface-0 sticky z-2 top-0 flex justify-content-center align-items-center"
                style={{
                    "--surface-0": "#fff",
                }}
            >
                <div className="flex-1 flex ml-3 mr-3">
                    <div className="flex-1 flex ">
                        <div className="ml-3 flex justify-content-center align-items-center">
                            <div className="h-1rem w-1rem border-circle flex justify-content-center align-items-center">
                                <i
                                    className="pi pi-angle-left cursor-pointer"
                                    onClick={() => handleBackButton()}
                                    style={{ fontSize: "27px", cursor: "pointer", color: "#000" }}
                                ></i>
                            </div>
                        </div>
                        <div className="flex-1 ml-5">
                            <p className=" text-2xl font-bold capitalize">Challan Info</p>
                        </div>
                    </div>

                    <div
                        className="flex justify-content-center align-items-center cursor-pointer"
                        onClick={() => setVisible(true)}
                    >
                        <i
                            className="pi pi-bars"
                            style={{ fontSize: "27px", marginRight: 30, color: "#000" }}
                        ></i>
                    </div>
                </div>
            </div>

            <div
                className="border-none surface-0 flex-1  mx-4 py-1 mb-3"
                style={{
                    borderRadius: 5,
                    backgroundImage:
                        "radial-gradient(circle at left top, #1752AA, #2B70D7)",
                }}
            >
                <div className="px-4">
                    <div
                        className="flex cursor-pointer"
                        onClick={() =>
                            navigate("/CustomerInfo", {
                                state: {
                                    storeCustomerId: storeCustomerId,
                                    storeId: storeId,
                                },
                            })
                        }
                    >
                        <div className="flex-1 flex justify-content-start align-items-center">
                            <p className="text-white text-lg font-normal capitalize">
                                Customer Name :
                            </p>
                            <p className="text-white text-xl font-semibold capitalize ml-2">
                                {CustomerInformation?.firstName} {CustomerInformation?.lastName}
                            </p>
                        </div>
                        <div className="flex-1 flex justify-content-start align-items-center">
                            <p className="text-white text-lg font-normal capitalize ">
                                Mobile No. :
                            </p>
                            <p className="text-white text-xl font-semibold capitalize ml-2">
                                {CustomerInformation?.mobile}
                            </p>
                        </div>
                    </div>
                </div>
            </div>
            <div className="flex flex-1 justify-content-around align-item-center">
                {["BOOKED"].includes(customerOrdersData.status) && (
                        renderCardOnDoneOrder()
                )}
                {customerOrdersData.status === "CANCEL" && renderCardAfterCancelOrder()}
            </div>
            <div className="flex flex-1">
                <div className="flex-1">
                    <div
                        className="flex-1  surface-0"
                        style={{ "--surface-0": "#EAEFF5", position: "relative" }}
                    >
                        <div className="flex justify-content-between mx-4">
                            <div className="py-1">
                                <p className=" text-2xl  font-bold ">Challan Info</p>
                            </div>
                        </div>
                        <div>
                            {!["ORDERED", "CANCEL"].includes(customerOrdersData.status) && (
                                <div
                                    style={{
                                        position: "absolute",
                                        right: 30,
                                        top: 9,
                                    }}
                                >
                                    <div>
                                        <div onClick={() => setOrderInfoEditVisible(true)}>
                                            <i
                                                className="pi pi-pencil"
                                                style={{
                                                    fontSize: "20px",
                                                    cursor: "pointer",
                                                    color: "#2B70D7",
                                                }}
                                            ></i>
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                    <B2BOrderInfoCard
                        customerOrdersData={customerOrdersData}
                        storeCustomerId={storeCustomerId}
                        bookingOrderId={bookingOrderId}
                        userRole={userRole}
                        storeId={storeId}
                        enabledChargeDiscountByService={enabledChargeDiscountByService}
                        storeUserId={storeUserId}
                        brandId={brandId}
                        enabledCreatePaymentLink={enabledCreatePaymentLink}
                        updateOrderGarmentInfoPage={receiveDataFromGarmentInfoCard}
                    />
                </div>
                <div className="flex-1">
                    <div
                        className="flex-1  surface-0"
                        style={{ "--surface-0": "#EAEFF5" }}
                    >
                        <div className="flex justify-content-between mx-4">
                            <div className="py-1">
                                <p className=" text-2xl  font-bold ">Garment Info</p>
                            </div>
                        </div>
                    </div>
                    <B2BGarmentInfoCard
                        orderItemData={orderItemData}
                        storeCustomerId={storeCustomerId}
                        storeId={storeId}
                        bookingOrderId={bookingOrderId}
                        brandId={brandId}
                        priceId={storeDefaultPrice.id}
                        sendDataToOrderGarmentInfo={receiveDataFromGarmentInfoCard}
                        offerDiscountByStore={offerDiscountByStore}
                        offerDiscountByRider={offerDiscountByRider}
                        userRole={userRole}
                        offerPriceEnabled={offerPriceEnabled}
                        garmentMaxProcessCount={garmentMaxProcessCount}
                        garmentServiceIcons={garmentCategoryServiceIconsResData?.iconMap}
                        enableDeleteItem={true}
                        customerOrdersData={customerOrdersData}
                    />
                </div>
            </div>
            <div>
                <B2BOrderInfoEdit
                    setOrderInfoEditVisible={setOrderInfoEditVisible}
                    orderInfoEditVisible={orderInfoEditVisible}
                    customerOrdersData={customerOrdersData}
                    storeId={storeId}
                    storeUserId={storeUserId}
                    storeCustomerId={storeCustomerId}
                    processTime={processTime}
                    sendResponse={receiveResponse}
                    storeGstNumber={storeGstNumber}
                    storeCustomerData={storeCustomerData}
                />
                <SuccessModal
                    setModalVisible={setModalVisible}
                    modalVisible={modalVisible}
                    status={modalStatusText}
                    text={modalText}
                />
                <B2BOrderCancelModal
                    setCancelOrderModal={setCancelOrderModal}
                    cancelOrderModal={cancelOrderModal}
                    sendDataToOrderInfoPage={receiveDataFromCancelModal}
                    storeId={storeId}
                    storeCustomerId={storeCustomerId}
                    bookingOrderId={bookingOrderId}
                />
                 
            </div>
            <AdminMenu setVisible={setVisible} visible={visible} />
        </div>
    );
};

export default B2BAdminOrdersGarmentInfo;
